<template>
  <div>
    <data-table :title="title"
                :service="ClientService"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                :operations="operations"
                operations-align="right"
                @fetch-data="onFetchData"
                ref="table">
      <template v-slot:extra-buttons="{row}">
        <template v-if="row.status === 'check'">
          <tooltip-icon-button type="success"
                               :content="$t('generic.approve')"
                               icon="nc-icon nc-check-2"
                               @click.stop="approveClient(row)">
          </tooltip-icon-button>
          <tooltip-icon-button type="danger"
                               :content="$t('generic.reject')"
                               icon="nc-icon nc-simple-remove"
                               @click.stop="rejectClient(row)">
          </tooltip-icon-button>
        </template>
      </template>
      <div class="d-flex align-items-center" slot="name" slot-scope="{row}">
        <base-avatar :name="row.name"
                     :src="row.image">
        </base-avatar>
        <div class="ml-2 font-weight-bold">{{row.name}}</div>
      </div>

      <template slot="type" slot-scope="{row}">
        {{row.type}}
      </template>

      <template slot="created_at" slot-scope="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>

      <status-badge slot="status" slot-scope="{row}" :status="row.status"/>
    </data-table>
  </div>
</template>
<script>
  import ClientService from 'src/services/ClientService';
  import entities from 'src/config/entities';
  import { clientStatus } from "src/config/clientEnums";
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'
  import TooltipIconButton from 'src/components/Buttons/TooltipIconButton'

  export default {
    components: {
      TooltipIconButton
    },
    props: {
      userId: {
        type: String
      },
      tableColumns: {
        type: Array
      },
      title: String,
      operations: {
        type: String,
        default: 'add,refresh,edit,delete'
      },
      filters: {
        type: Array,
        default: () => [
          {
            key: 'sort',
            value: '-name'
          }
        ]
      }
    },
    data() {
      return {
        FRIENDLY_DATETIME_FORMAT,
        ClientService,
        entity: entities.CLIENT,
        statusMapping: {
          [clientStatus.ACTIVE]: 'info',
          [clientStatus.CHECK]: 'success',
          [clientStatus.BLOCKED]: 'danger',
        }
      }
    },
    computed: {
      columns() {
        return this.tableColumns || [
          {
            prop: "name",
            label: this.$t('client.list.labels.name'),
            minWidth: "150px",
            sortable: true
          },
          {
            prop: "type",
            label: this.$t('client.list.labels.type'),
            minWidth: "150px",
            sortable: true
          },
          {
            prop: "created_at",
            label: this.$t('generic.createdAt'),
            minWidth: "150px",
            sortable: true
          },
          {
            prop: "status",
            label: this.$t('client.list.labels.status'),
            minWidth: "150px",
            sortable: true
          }
        ]
      }
    },
    methods: {
      onFetchData(response) {
        this.$emit('fetch-data', response);
      },
      async approveClient(row) {
        let newStatus = 'active'
        await ClientService.verify(row.uuid, {
          status: newStatus
        })
        row.status = newStatus
      },
      async rejectClient(row) {
        let newStatus = 'blocked'
        await ClientService.verify(row.uuid, {
          status: newStatus
        })
        row.status = newStatus
      },
    }
  }
</script>
<style>
</style>
